import { getErrorMessage } from "@/core/api/helpers"
import { useAppDispatch } from "@/redux/hooks"
import { useAddEmailAddressMutation } from "@/redux/services/sendersApi"
import { setToast } from "@/redux/toastSlice"
import type { AddEmailAddressPayload } from "@/types/entities/email-address"

export const useAddEmailAddress = () => {
  const dispatch = useAppDispatch()
  const [addEmailAddress, response] = useAddEmailAddressMutation()

  const handleAddEmailAddress = async ({
    body,
    id,
  }: {
    body: AddEmailAddressPayload
    id: string
  }) => {
    try {
      const response = await addEmailAddress({ body, id }).unwrap()
      if (response) {
        dispatch(
          setToast({
            show: true,
            variant: "success",
            message: "Success add email address",
          }),
        )
      }
      return response
    } catch (error: any) {
      const message = getErrorMessage(error)
      dispatch(
        setToast({
          show: true,
          variant: "error",
          message,
        }),
      )
      throw new Error(message)
    }
  }

  return { addEmailAddress: handleAddEmailAddress, response }
}
